/* @flow */
import _ from 'lodash';

/* Helper function to connect props with classnames
 *
 * const props = {
 *   color: 'green',
 * }
 *
 * const propsToClasses = {
 *   color: {
 *     green: 'green-class',
 *     red: 'red-class',
 *   }
 * }
 *
 * <div classNames={getPropClassesFromInstance(this)} />
 */
export function getPropClassesFromInstance(
  componentInstance: React$Component<*, *>,
  filteredProps?: string[]
): string[] {
  return getPropClasses(
    componentInstance.props,
    // $FlowFixMe property `propClasses` of unknown type
    componentInstance.constructor.propClasses || {},
    filteredProps
  );
}

/* If you don't have a component instance, like in a stateless function
 * want you can use getPropClasses directly.
 *
 * const props = {
 *   color: 'green',
 * }
 *
 * const propsToClasses = {
 *   color: {
 *     green: 'green-class',
 *     red: 'red-class',
 *   }
 * }
 *
 * <div classNames={getPropClasses(props, propsToClasses)} />
 */
export default function getPropClasses(
  props: Object,
  propsToClasses: Object,
  filteredProps?: string[]
): string[] {
  const whiteListedProps = filteredProps || Object.keys(propsToClasses);

  const propBasedClasses = whiteListedProps.reduce((classNames, prop) => {
    const propVal = props[prop];
    if (propVal) {
      if (propVal === true) {
        classNames.push(propsToClasses[prop]);
      } else if (propVal in propsToClasses[prop]) {
        classNames.push(propsToClasses[prop][propVal]);
      }
    }

    return classNames;
  }, []);

  // some propToClasses map to null values
  return _.compact(propBasedClasses);
}
